import React from "react"
import { useNavigate } from "react-router-dom"
import { FileText, Package, Receipt, Scale } from "lucide-react"
import Spinner from "react-bootstrap/Spinner"
import Button from "../common/Button.jsx"

function TabButton({
    isActive,
    children,
    icon,
    onClick,
    implemented = false,
}) {
    const clickable = !isActive && typeof onClick === "function"
    const isPlaceholder = !implemented
    return (
        <button
            className={`btn d-flex align-items-center rounded me-2 ${
                isActive ? "text-white" : "btn-outline-secondary"
            } ${isPlaceholder ? "v2-not-implemented-btn" : ""}`}
            type="button"
            onClick={clickable ? onClick : undefined}
            aria-disabled={isActive ? "true" : undefined}
            tabIndex={isActive ? -1 : 0}
            style={{
                ...(isActive ?
                    {
                        backgroundColor: "#0f6170",
                        borderColor: "#0f6170",
                        fontSize: "0.875rem",
                        fontWeight: 500,
                    } :
                    {
                        fontSize: "0.875rem",
                        fontWeight: 500,
                    }),
                cursor: clickable ? "pointer" : "default",
            }}
            title={isPlaceholder ? "Not implemented yet" : undefined}
        >
            {icon && <span className="me-2">{icon}</span>}
            {children}
        </button>
    )
}

function getDisplayName(firstName, lastName) {
    return `${firstName || ""} ${lastName || ""}`.trim()
}

export default function OrderDetailLayoutHeader({
    orderMaster,
    firstName,
    lastName,
    activeTab = "order",
    orderId = "",
    showOrderNav = true,
    onNotImplemented = undefined,
    onCustomerDetailsClick = undefined,
    isCustomerDetailsLoading = false,
    alertsSlot = null,
}) {
    const displayName = getDisplayName(firstName, lastName)
    const navigate = useNavigate()
    const resolvedOrderId = String(orderId || "").trim()
    const canNavigateOrder = resolvedOrderId !== ""

    return (
        <>
            <div className="pt-4 mb-3 min-w-0">
                <h1 className="fs-2 fw-bold text-dark mb-2 text-truncate">
                    #{orderMaster}{displayName ? ` - ${displayName}` : ""}
                </h1>
                {alertsSlot}
                <Button
                    variant="outline"
                    size="sm"
                    className={`text-nowrap ${
                        onCustomerDetailsClick ? "" : "v2-not-implemented-btn"
                    }`}
                    onClick={isCustomerDetailsLoading ? undefined : (onCustomerDetailsClick ?? onNotImplemented)}
                    disabled={Boolean(isCustomerDetailsLoading)}
                    title={onCustomerDetailsClick ? undefined : "Not implemented yet"}
                    icon={
                        isCustomerDetailsLoading ? <Spinner animation="border" size="sm" /> : null
                    }
                >
                    Customer Details
                </Button>
            </div>
            {showOrderNav ? (
                <div className="d-flex overflow-auto pb-2 mb-3 min-w-0" style={{ maxWidth: "100%" }}>
                    <TabButton
                        isActive={activeTab === "order"}
                        icon={<FileText size={16} />}
                        implemented
                        onClick={
                            !canNavigateOrder ?
                                undefined :
                                () => navigate(`/v2/orders/${resolvedOrderId}/order`)
                        }
                    >
                        Order
                    </TabButton>
                    <TabButton
                        isActive={activeTab === "weigh-in"}
                        icon={<Scale size={16} />}
                        onClick={onNotImplemented}
                    >
                        Weigh In
                    </TabButton>
                    <TabButton
                        isActive={activeTab === "box-up"}
                        icon={<Package size={16} />}
                        onClick={onNotImplemented}
                    >
                        Box Up
                    </TabButton>
                    <TabButton
                        isActive={activeTab === "invoice"}
                        icon={<Receipt size={16} />}
                        onClick={onNotImplemented}
                    >
                        Invoice
                    </TabButton>
                </div>
            ) : null}
        </>
    )
}
